import { Button } from '@shoflo/polymer/components/Button/Button';
import styled from 'styled-components';
import { ModalFooter } from 'reactstrap';

export const StyledButton = styled(Button)`
  border: 1px solid #dfe3ec;
  background-color: #ffffff;
  color: #33373d;
  display: block;
  &:hover,
  &:focus {
    border: 1px solid #000000 !important;
    background-color: #ffffff !important;
    color: #33373d !important;
    display: block !important;
  }
`;

export const StyledModalFooter = styled(ModalFooter)`
  padding-top: 0px;
`;
